import React, { useState, useEffect } from "react";
import { Card, Select, Loader, Center, SimpleGrid, Text, Group, Alert, Button } from "@mantine/core";
import axiosInstance from "../../services/axiosInstance";

const Report = () => {
    const [dateRange, setDateRange] = useState("today");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        const controller = new AbortController();
        setLoading(true);
        setError("");
        setData([]);
        axiosInstance.get("/reports/leads", { params: { period: dateRange }, signal: controller.signal })
            .then(response => { if (!controller.signal.aborted) setData(response.data.items); })
            .catch(err => {
                if (!controller.signal.aborted) setError(err.response?.data?.error || "Не вдалося завантажити звіт. Спробуйте ще раз.");
            })
            .finally(() => { if (!controller.signal.aborted) setLoading(false); });
        return () => controller.abort();
    }, [dateRange, refresh]);

    return (
        <div>
            <div className="workspace-heading"><div><h2>Leads Report</h2><p>Fluxar · Групи оферів та гео · Europe/Kyiv</p></div></div>
            <Group mb="md">
                <Text>Оберіть період:</Text>
                <Select
                    size="sm"
                    value={dateRange}
                    onChange={setDateRange}
                    data={[
                        { value: "today", label: "Сьогодні" },
                        { value: "yesterday", label: "Вчора" },
                        { value: "7_days_ago", label: "Останні 7 днів" },
                        { value: "first_day_of_this_month", label: "Цей місяць" },
                        { value: "previous_month", label: "Попередній місяць" },
                    ]}
                    style={{ width: 180 }}
                    allowDeselect={false}
                />
                <Button size="xs" variant="light" loading={loading} onClick={() => setRefresh(value => value + 1)}>Оновити</Button>
            </Group>
            <Text size="xs" c="dimmed" mb="md">Усі заявки: очікують + підтверджені + відхилені. Період визначається за датою кліку.</Text>

            {error ? <Alert color="red" role="alert">{error}</Alert> : loading ? (
                <Center h={200}>
                    <Loader />
                </Center>
            ) : data.length === 0 ? <Text c="dimmed">За обраний період заявок немає.</Text> : (
                <SimpleGrid cols={{ base: 1, sm: 2, md: 3, lg: 4 }} spacing="xs">
                    {data.map((item) => (
                        <Card
                            key={item.id}
                            withBorder
                            shadow="sm"
                            padding="sm"
                            radius="md"
                        >
                            <Card.Section withBorder inheritPadding py="xs">
                                <Text size="xs" fw={700}>{item.name} · {item.total}</Text>
                            </Card.Section>
                            <Card.Section inheritPadding py="xs">
                                <div style={{ fontSize: "12px" }}>
                                    {Object.entries(item.countries).sort(([a], [b]) => a.localeCompare(b)).map(
                                        ([country, value]) => (
                                            <div
                                                key={country}
                                                style={{ marginBottom: 4 }}
                                            >
                                                {country}: <strong>{value}</strong>
                                            </div>
                                        )
                                    )}
                                </div>
                            </Card.Section>
                        </Card>
                    ))}
                </SimpleGrid>
            )}
        </div>
    );
};

export default Report;
